import { Link as MortarLink } from '@policygenius/mortar';
import React, { MouseEvent } from 'react';

export interface Props extends MortarLink.Props {
  children: React.ReactNode;
}

const Link: React.FC<Props> = ({
  children,
  className,
  href,
  onClick,
  size,
  target,
  variant,
  ...otherLinkProps
}) => {
  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (
    event: MouseEvent<HTMLAnchorElement>
  ) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <MortarLink
      variant={variant}
      className={className}
      href={href}
      onClick={handleClick}
      size={size}
      target={target}
      {...otherLinkProps}
    >
      {children}
    </MortarLink>
  );
};

export default Link;
